export default {
    name: 'userAccount',
    data: 'data',
};
